import { allImagesLoaded } from '@Utils/all-images-loaded';

function saveInlineCSS($el) {
    if ($el.length) {
        $el.data('inline-css', $el.attr('style'));
    }
}

function restoreInlineCSS($el) {
    if ($el.length) {
        $el.attr('style','');
    
        if (!$el.data('inline-css')) return;

        $el.attr('style', $el.data('inline-css'));
    }
}

function setRwdStyle($image, rwdStyle) {
    const $figure = $image.parent('figure');
    
    $.each(rwdStyle, function(property, value) {
        if (property === 'margin') {
            $image.css(property, 'auto');
            $figure.css(property, value);
        } else {
            $image.css(property, value);
            $figure.css(property, value);
        }
    });
}

function resizeHandler($images, config) {
    if ($('body').width() >= config.maxBodyWidth) {
        $images.each(function() {
            const $image = $(this);
            
            if (!config.isDisabled($image)) {
                restoreInlineCSS($image);
                restoreInlineCSS($image.parent('figure'));
            }
            
        });
            
        return;
    }	
        
    $images.each(function() {
        const $image = $(this);
        
        if (!config.isDisabled($image)) {
            const $parent = $image.parents(config.context).first();
            
            if ($image.width() > (50 * $parent.width()) / 100) {
                setRwdStyle($image, config.rwdStyle);
            } else {
                restoreInlineCSS($image);
                restoreInlineCSS($image.parent('figure'));
            }
        } 
    });
}

function init(initialConfig) {
    const config = {
        context: 'body',
        maxBodyWidth: 1024,
        isDisabled: function($image) {
            return $image.hasClass('disable-block-image') ||
                    $image.hasClass('has-disabled-rwd') || 
                    $image.hasClass('ci-rwd-img-disabled') || 
                    $image.hasClass('is-extended-image') ||
                    ($image.parent('figure').length && $image.parent('figure').hasClass('is-extended-image'));
        },
        rwdStyle: {
            'display': 'block',
            'margin': '20px auto',
            'float': 'none',
            'max-width': '100%',
            'height': 'auto',
            'padding-top': '0',
            'padding-right': '0',
            'padding-bottom': '0',
            'padding-left': '0'
        }
    };
    
    if (initialConfig) {
        $.extend(config, initialConfig);
    }

    allImagesLoaded(function($images) {
        $images.each(function() {
            const $image = $(this);
            
            saveInlineCSS($image);
            saveInlineCSS($image.parent('figure'));
        });
        
        resizeHandler($images, config);
        $(window).on('resize', function() {
            resizeHandler($images, config);
        });
    }, config.context);
}

export {
    init
}